module.exports = __webpack_public_path__ + "fonts/KaTeX_Typewriter-Regular.6bf42875.ttf";